import React from 'react';

import { StyledStatusText } from './SplashScreen.styles';

const StatusText = ({ text }) => {
  return <StyledStatusText>{text}</StyledStatusText>;
};

export default StatusText;
